import { render, staticRenderFns } from "./CourseByTerm.vue?vue&type=template&id=14388a35&scoped=true"
import script from "./CourseByTerm.vue?vue&type=script&lang=js"
export * from "./CourseByTerm.vue?vue&type=script&lang=js"
import style0 from "./CourseByTerm.vue?vue&type=style&index=0&id=14388a35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14388a35",
  null
  
)

export default component.exports